import PropTypes from 'prop-types';
import Price from '../../../molecules/price/Price';
import { Text } from '../../../typography/text/Text';
import defaultClasses from './OrderSummary.module.scss';
import React from 'react';
import mergeClasses from '../../../../utils/shallowMerge';
import { useShippingCost } from '../../../../hooks/useShippingCost';
import clsx from 'clsx';
import { objSettings } from './options';

const OrderSummaryShippingLineItem = ({
  showCurrency = true,
  showSubtitle = false,
  customClasses = {},
  shippingMessages = '',
}) => {
  const {
    price,
    freeAboveFormatted,
    currentMethodTitle,
  } = useShippingCost();

  const buildSpan = (text, className) => (
    <Text
      as="span"
      textTransform="firstletter"
      align="start"
      size="s"
      className={className}
    >
      {text}
    </Text>
  );
  const styles = mergeClasses(defaultClasses, customClasses);

  const getShippingMessage = () => {
    if (!shippingMessages && !currentMethodTitle) return null;

    if (currentMethodTitle) {
      return freeAboveFormatted ? `${currentMethodTitle} ${freeAboveFormatted}` : currentMethodTitle;
    }

    return freeAboveFormatted ? `${shippingMessages} ${freeAboveFormatted}` : shippingMessages;
  }

  return (
    <div
      className={clsx({
        [styles.shippingWrapper]: true,
        [styles.shippingBlock]: !objSettings.isSc,
        [styles.minicartShippingText]: customClasses?.minicartShippingText,
      })}
    >
      <div className={clsx(styles.summaryText, styles.summaryHeight)}>
        {buildSpan('Shipping:')}
        {price > 0 ? (
          <Price
            placement="totals"
            type="regular"
            value={price}
            showCurrency={showCurrency}
          />
        ) : (
          buildSpan('Free', styles.price)
        )}
      </div>
      {(showSubtitle && getShippingMessage()) && (
        <div className={styles.freeShippingMessage}>
          <Text as="span" textTransform="none" align="start">
            {getShippingMessage()}
          </Text>
        </div>
      )}
    </div>
  );
};

OrderSummaryShippingLineItem.propTypes = {
  showCurrency: PropTypes.bool,
  showSubtitle: PropTypes.bool,
  customClasses: PropTypes.object,
  shippingCostMessage: PropTypes.string,
};

export default OrderSummaryShippingLineItem;
